import { Icon } from '@blueprintjs/core';
import { Group } from '@mantine/core';
import { SmallerText, Text } from '@pages/Products/Products.styles';

const LENGTH_LIMIT = 1000000;
export function GroupEditWarn({ length }: { length: number }) {
  const truncatedLen = length > LENGTH_LIMIT ? `${LENGTH_LIMIT - 1}+` : length;
  return (
    <Group spacing={8} mb={16} className="group_warning">
      <Text className="no-margin">{truncatedLen} Assets Selected</Text>
      <Group spacing={4} data-enable-new-icon>
        <Icon icon="error" color="#FF9900" size={14} />
        <SmallerText>
          Single edit limit reached. Below is a preview of the first 20 items
          selected
        </SmallerText>
      </Group>
    </Group>
  );
}
